module.exports = __webpack_public_path__ + "static/media/money.2905a118.svg";